<template>
  <div class="shadow sticky top-[100vh">
    <footer
      class="flex h-14 justify-between items-center px-12 sm:px-6 lg:px-12 bg-white font-lufga font-normal text-neautrals-400 text-base"
    >
      <div>{{ $t("copyRight") }}</div>
      <div>Privacy notice</div>
    </footer>
  </div>
</template>
